export interface UicSustainabilityLink {
  label: string
  href: string
  highlight?: boolean
}

export const UIC_SUSTAINABILITY_LINKS: UicSustainabilityLink[] = [
  {
    label: "Sustainability",
    href: "https://uic.org/sustainability/",
  },
  {
    label: "Air Quality",
    href: "https://uic.org/sustainability/air-quality/",
  },
  {
    label: "Circular Economy",
    href: "https://uic.org/sustainability/circular-economy/",
  },
  {
    label: "Energy Efficiency & CO₂ Emissions",
    href: "https://uic.org/sustainability/energy-efficiency-and-co2-emissions/",
  },
  {
    label: "Noise & Vibration",
    href: "https://uic.org/sustainability/noise-and-vibration/",
  },
  {
    label: "Sustainable Land Use",
    href: "https://uic.org/sustainability/sustainable-land-use/",
  },
  {
    label: "UIC Sustainability Awards 2026",
    href: "https://uic.org/event/uic-sustainability-awards/",
    highlight: true,
  },
]
